import React from "react";
import { useState } from 'react';
//React Router
import { useNavigate } from 'react-router-dom'

// tools and component for date picker
import dayjs from 'dayjs';

//selectors for redux :
import { useSelector } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier, getUserData, getCommentaire, getAccess, getContrat } from "../../../../../../store/selectors.js";
import { useDispatch } from "react-redux";
import { contratSlice } from "../../../../../../store/contratSlice.js";
import { contratStepSlice } from "../../../../../../store/contratStepSlice.js";

//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MoneyIcon from '@mui/icons-material/Money';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';



//import Fetch API functions
import { getArticles, getOneSpot, getAllTarifs, getAccessoires } from '../../../../../../database/fetchApi.js'

//created components
import BlocRecap from '../../../../../../steps/step5/components/blocrecap/BlocRecap.jsx'
import BlocRecapFixe from '../../components/blocrecap/BlocRecapFixe.jsx'

//Utils functions
import { prepareDureeTexte } from '../../../../../../utils/calcul_duree.js'
import calculDuree from '../../../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { calcPrixDegressif } from "../../../../../../utils/calcul_prix.js" //parms : tarifs object, duree object
import { prepAdresse } from '../../../../../../utils/prepa_adresse_paiement.js'; //url preparation for axepta
import prepaMailContrat from "../../../../../../utils/prepa-mail-contrat.js" //params : fullContrat 
import prepaMail from "../../../../../../utils/prepa-mail.js" //params : fullContrat 

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../../../../config/api-config.js';
import { IndeterminateCheckBoxOutlined } from "@mui/icons-material";

function StepSix() { // component to manage the first step of shopping : choosing place and time

    const [articles, setArticles] = useState([]);
    const [accessoires, setAccessoires] = useState([]);
    const [tarifs, setTarifs] = useState([]);
    const [spotInfos, setSpotInfos] = useState(null); //null is set by default so we can 
    const [fail, setFail] = useState(false); //state : api request failed
    const [infos, setInfos] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [ref, setRef] = React.useState("");
    const [contratID, setContratID] = React.useState();
    const [paymentUrl, setPaymentUrl] = useState(""); //state : api request failed
    const [lock, setLock] = useState(true); //state : modify total price
    const [showLoading, setShowLoading] = useState(false);

    let successRequest = 0;

    const idSpot = useSelector(getIdSpot); //global state : id of the selected spo
    const accessList = useSelector(getAccess); //global state : id of the selected spo
    const infosLivraison = useSelector(getLivraison); //global state : id of the selected spo
    const period = useSelector(getRidingPeriod); //global state : id of the selected spo
    const userInfos = useSelector(getUserData); //global state : id of the selected spo
    let panier = useSelector(getPanier); //get global state : panier
    let commentaire = useSelector(getCommentaire); //get global state : panier
    let currentContrat = useSelector(getContrat); //get global state : panier

    const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)

    let periode = useSelector(getRidingPeriod);

    const [customPrice, setCustomPrice] = useState(0); //state : modify total price
    const [cumulPrice, setCumulPrice] = useState(0); //state : modify total price
    const [priceError, setPriceError] = useState(false); //state : modify total price
    const [paiementModes, setPaiementModes] = useState([{ type: 2, montant: 0 }]); //state : modify total price
    const [cumulError, setCumulError] = useState(false); //state : modify total price
    const [cautionType, setCautionType] = useState(0); //state : modify total price
    const [cautionDetails, setCautionDetails] = useState(currentContrat.garantie); //state : modify total price
    const [comment2, setComment2] = useState(""); //state : modify total price
    const [mailChecked, setMailChecked] = useState(true); //state : modify total price
    const [insertError, setInsertError] = useState(""); //state : modify total price
    //let paiementModes = [{ type: 2, montant: 0 }];
    let paiementModesList = [
        { type: 2, intitule: "Espèces" },
        { type: 3, intitule: "CB" },
        { type: 4, intitule: "Chèque" },
        { type: 5, intitule: "ANCV" },
        { type: 6, intitule: "Virement" }
    ];

    let garantiesList = [
        "- Choisissez -", "Pièce d'identité", "Empreinte CB", "Chèque", "Autre"
    ];


    const dispatch = useDispatch();
    const navigate = useNavigate();


    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initAccessoires() { //we add this inner function to manage asynchrone
            let allAccessoires = await getAccessoires();
            setAccessoires([].concat(allAccessoires))
        } //end of async function
        initAccessoires(); //call the inner asnchrone function

        async function initSpot() { //we add this inner function to manage asynchrone
            let infosSpot = await getOneSpot(idSpot);
            setSpotInfos(infosSpot)
        } //end of async function
        initSpot(); //call the inner asnchrone function 

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 

        console.log("rendu");
        //setCustomPrice(getCumul().total);
    }, [])

    React.useEffect(() => { //reset customprice on lock
        if (lock === true) {
            setCustomPrice(getCumul().du);
        }
    }, [lock])

    React.useEffect(() => { //reset customprice on lock

        if (panier.length > 0 && articles.length > 0) {
            setCustomPrice(getCumul().du);
            setPaiementModes([{ type: 2, montant: getCumul().du }])

        }

    }, [panier, articles])






    function findArticle(id) {
        try {
            return articles.find((item) => item.id_article === id);

        }
        catch {
            //console.log('error find')
        }
    }

    function getCumul() {
        let total = 0;
        let lignes = [];

        if (panier.length > 0) {
            panier.map((ligne) => {
                let articleCourant = findArticle(ligne.id_article);
                if (typeof articleCourant !== 'undefined') {
                    let pu = ligne.qte * calcPrixDegressif(articleCourant.Tarif, calculDuree(periode));
                    //let infosArticle = ligne.qte + " x " + articleCourant.type + " : " + pu + ",00€";
                    let infosArticle = { qte: ligne.qte, type: articleCourant.type, pu };
                    total += pu;
                    lignes.push(infosArticle);
                }
            });
        }

        let du = total - currentContrat.total > 0 ? total - currentContrat.total : 0;

        return { total, lignes, du };
    }




    function getUserInfos(infos) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        return (
            <div className="bloc-recap-infos-user">
                <p>{infos.prenom} {infos.nom}</p>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.tel}</p>
                    <p>{infos.email}</p>
                </div>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.adresse}, {infos.adresse_comp}</p>
                    <p>{infos.cp}, {infos.ville}, {infos.pays}</p>
                </div>



            </div>
        )
    }

    function getPeriodInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let dateDeb = "";
        let dateFin = "";
        let duree = "";

        //prepare dates infos
        dateDeb += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
        dateDeb += " à " + period[1][0] + "h00";
        dateFin += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
        dateFin += " à " + period[1][1] + "h00";

        //Prepare duree infos
        duree = prepareDureeTexte(dureeObject);

        return (
            <div className="bloc-recap-infos-duree">
                <p className="bloc-recap-infos-duree-date">{dateDeb}</p>
                <p className="bloc-recap-infos-duree-date">{dateFin}</p>
                <p className="bloc-recap-infos-duree-cumul">soit : {duree}</p>
            </div>
        )
    }

    function getSpotInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let spot1 = "";
        let spot2 = "";
        let spot3 = "";

        // prepare spot infos
        if (idSpot >= 99) {
            spot1 = "Livraison : " + infosLivraison.secteur; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
            spot2 = infosLivraison.adresse; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
            spot3 = infosLivraison.comp; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
        }
        else { // spot is not livraion
            if (spotInfos) { // if promise not fullfilled yet, we block the process to evoid error
                spot1 = spotInfos.nom_spot;
                spot2 = spotInfos.adresse_spot + " " + spotInfos.ville_spot;
            }
        }

        return (
            <div className="bloc-recap-infos-spot">
                <p>{spot1}</p>
                <p>{spot2}</p>
                <p>{spot3}</p>
            </div>
        )
    }

    function getLivraisonComp(comp) {
        let info = " ";
        info += comp === undefined ? "" : comp;
        return info;
    }

    function getCartInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        let { total, lignes, du } = getCumul();


        return (
            <div className="bloc-recap-infos-cart">
                <div className="bloc-recap-infos-cart-top">
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Article</TableCell>
                                <TableCell align="center">Quantité</TableCell>
                                <TableCell align="center">Tarif</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lignes.map((row) => (
                                <TableRow
                                    key={row.type}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.type}
                                    </TableCell>
                                    <TableCell align="center">{row.qte}</TableCell>
                                    <TableCell align="center">{row.pu},00€</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </div>
                <div className="bloc-recap-infos-cart-modif">
                    <h3>Montant total du panier :</h3>
                    <p>{total},00 €</p>
                </div>

                <div className="bloc-recap-infos-cart-regle">
                    <h3>Déjà réglé :</h3>
                    <p>{currentContrat.total},00 €</p>
                </div>

                <div className="bloc-recap-infos-cart-total">

                    <h3>Restant dû :</h3>
                    <p>{du},00 €</p>
                </div>




            </div>
        )
    }







    function modifContrat() {

        setShowLoading(true);

        let adresseLivraison = idSpot < 99 ? "-" : infosLivraison.secteur + "," + infosLivraison.adresse + "," + infosLivraison.comp;

        let body = {
            date1: period[0][0],
            date2: period[0][1],
            h1: period[1][0],
            h2: period[1][1],
            commentaire: currentContrat.commentaire + " // " + comment2,
            spot_id: idSpot,
            livraison: idSpot === 99,
            adresse_livraison: adresseLivraison
        }

        axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, body)
            .then((response) => {
                if (response.status === 200) { //isnertion OK
                    successRequest++;
                    insertClient()

                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de la création du contrat. Vous pouvez essayer à nouveau");
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                setInsertError("Erreur lors de la création du contrat. Vous pouvez essayer à nouveau");
                return error
            })

    }

    function insertClient() {
        // update user

        axios.put(`${baseURL}/client/${userInfos.id_client}`, {
            email: userInfos.email,
            prenom: userInfos.prenom,
            nom: userInfos.nom,
            adresse: userInfos.adresse,
            adresse_comp: userInfos.adresse_comp,
            cp: userInfos.cp,
            ville: userInfos.ville,
            country: userInfos.pays
        })
            .then((response) => {
                if (response.status === 200) { //isnertion OK

                    // we force update just to get response with all jointured tables
                    axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, {
                        solde: 0
                    })
                        .then((resp) => {
                            if (resp.status === 200) { //isnertion OK
                                sendMail(resp.data.data);
                            }
                        })

                }
                else { //insertion problème
                    setFail(true); //to trigger alert message
                    setInsertError("Erreur lors de la modif du client. Vous pouvez essayer à nouveau");
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                setInsertError("Erreur lors de la modif duu client. Vous pouvez essayer à nouveau");
                return error
            })


    }










    /*   function fillCaisse() {
  
          // we force update just to get response with all jointured tables
          axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, {
              solde: 0
          })
              .then((response) => {
                  if (response.status === 200) { //isnertion OK
  
                      //// -- remplir caisee
                      let fullContrat = response.data.data; //remplir les infos de caisse
                      console.log(fullContrat)
                      let batch = [];
  
                      paiementModes.map((ligne) => { // for each article of the panier...
  
                          let body = {//prepare the json body sent in request{
                              contrat_id: fullContrat.id_contrat,
                              ref_contrat: fullContrat.ref_contrat,
                              type_paiement: ligne.type,
                              montant: ligne.montant,
                              date_paiement: dayjs().format("YYYY-MM-DD")
                          }
  
                          batch.push(body);
  
  
                      })//end of map
  
  
  
                      axios.post(`${baseURL}/caisse/bulk`, batch)
                          .then((response) => {
                              if (response.status === 201) { //isnertion OK
                                  console.log(response.data)
                                  sendMail(fullContrat);
  
                              }
                              else { //insertion problème
                                  setFail(true); //to trigger alert message
                                  setInsertError("Erreur lors de l'ajout des infos de caisse. Vous pouvez essayer à nouveau");
                                  return response.status
                              }
                          })
                          .catch(error => {
                              setFail(true); //to trigger alert message
                              setInsertError("Erreur lors de l'ajout des infos de caisse. Vous pouvez essayer à nouveau");
                              return error
                          })
  
  
  
  
                  }
                  else { //insertion problème
                      return response.status
                      console.log(response.status);
                  }
              })
              .catch(error => {
                  return error
                  console.log(error);
              })
  
  
  
      }
   */



    function sendMail(fullContrat) {

        if (mailChecked === true) {

            let body = {
                //to: "manuel.vivion@gmail.com",
                to: fullContrat.Client.email,
                bcc: "sylvainboufflers2@gmail.com,manuel.vivion@gmail.com",
                subject: "[Réservation vélos] - Modif - " + fullContrat.ref_contrat,
                html: prepaMail(fullContrat, articles, dureeObject, tarifs)
            };

            axios.post(`${baseURL}/mailing/mail-confirm`, body)
                .then((response) => {
                    setOpen(false) // --> fermer modal 

                    if (response.status === 200) { //isnertion OK

                        //Manager Mode : 
                        setShowLoading(false);
                        dispatch(contratSlice.actions.setContrat(fullContrat)); //
                        dispatch(contratStepSlice.actions.nextContratStep()); //go to confirmation
                        /// --

                    }
                    else { //insertion problème

                        //// ---
                        setInsertError("Erreur lors de l'envoie du mail de confirmation. Vous pouvez essayer à nouveau");
                        /// --
                    }
                })
                .catch(error => {
                    setOpen(false) // --> fermer modal 
                    //// ---
                    setInsertError("Erreur lors de l'envoie du mail de confirmation. Vous pouvez essayer à nouveau");
                    /// --

                })
        }
        else {
            //Everything ok, so  we update contrat to confirm
            dispatch(contratSlice.actions.setContrat(fullContrat)); //
            dispatch(contratStepSlice.actions.nextContratStep()); //go to confirmation
        }
    }


    return (
        <div className="step5">
            <div className="step5-top">
                <h1>Recapitulatif des modifications de la résa.</h1>
            </div>
            <div className="step5-blocs">
                <div className="step5-blocs-left">

                    <BlocRecap step={1} edit={true} titre={"Durée de location :"} infos={getPeriodInfos()} />
                    <BlocRecapFixe step={2} edit={true} titre={"Les articles :"} infos={getCartInfos()} />

                </div>
                <div className="step5-blocs-right">
                    <BlocRecap step={1} edit={true} titre={"Le point de location :"} infos={getSpotInfos()} />
                    <BlocRecap step={4} edit={true} titre={"Informations client :"} infos={getUserInfos(userInfos)} />
                </div>

            </div>





            <div className="step6-mode-paiement">
                <h3>Commentaire :</h3>


                <div className="bloc-recap-infos-cart-bottom">
                    {
                        commentaire.length > 1 ? //display only if commentaire is set
                            <div>
                                <p>Commentaire : {commentaire}</p>
                            </div>
                            : null
                    }

                </div>

                <div className="panier-modal-bottom-commentaires">
                    <TextField
                        fullWidth
                        label="Commentaire additionnel"
                        placeholder="facultatif"
                        /* defaultValue=" " */
                        value={comment2}
                        onChange={e => setComment2(e.target.value)}
                        multiline
                        maxRows={3}
                    />
                </div>
            </div>

            <FormControlLabel
                className="contrat-location-middle-checkbox"
                /* required */
                control={<Checkbox
                    onChange={_ => setMailChecked(!mailChecked)}
                    checked={mailChecked}
                />}
                label="Envoyer mail de confirmation"

            />

            <div className="step5-bottom">
                {fail ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        Une erreur réseau s'est produite, nous ne pouvons passer au paiement.
                    </Alert>
                    : null
                }
                {cumulError ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        Le cumul des moyens de paiement ne correspond pas au montant à payer
                    </Alert>
                    : null
                }
                {insertError.length > 0 ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        {insertError}
                    </Alert>
                    : null
                }

                <Button
                    disabled={false}
                    className="bouton-valid-cmd"
                    variant="contained"
                    onClick={_ => modifContrat()}
                >Valider les Modifications
                </Button>
                {showLoading === true ?
                    <CircularProgress />
                    : null
                }



            </div>


        </div>

    )
}




export default StepSix